import { render } from "./App.vue?vue&type=template&id=88fbbdb8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=88fbbdb8&lang=scss"

import exportComponent from "D:\\project_h5\\mydyH5_Code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__